import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/profile';
import {
  wotcSurveyDataKey,
  wotcSurveyRoute,
} from '@features/wotc';
import axiosInstance from '@server/axiosInstance';
import { notificationsKey } from '@features/notifications';

type usePostWotcSurveyProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const usePostWotcSurvey = ({
  setErrorText = () => { },
}: usePostWotcSurveyProps) => {
  const client = useQueryClient();

  const {
    mutate: sendWotcSurvey,
    isLoading: isSendingWotcSurvey,
  } = useMutation({
    mutationFn: (variables: any) =>
      axiosInstance
        .post(wotcSurveyRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      setErrorText('');
      client.invalidateQueries([wotcSurveyDataKey]);
      client.invalidateQueries([notificationsKey]);
    },
    onError: () => setErrorText(errorMessage),
  });

  return {
    sendWotcSurvey,
    isSendingWotcSurvey,
  };
};
